import { Button, ButtonProps } from '@mui/material';
import { observer } from 'mobx-react';
import styles from './index.module.scss';

interface commonButtonProps extends ButtonProps {
  children: React.ReactElement | string;
}

const commonButton: React.FC<commonButtonProps> = observer(({ children, ...rest }) => {
  return (
    <div className={styles.btn_wrap}>
      <Button {...rest} style={{ ...rest.style, textTransform: 'none' }}>
        {children}
      </Button>
    </div>
  );
});

export default commonButton;
